export default __webpack_public_path__ + "static/media/boat.179bef37.webp";